import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useRecentFiltersDisplay} from "../hooks/use_recent_filters_display";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {getFilterTextParts, getRecentFilterFilterText, getRecentFilterSearchUrlWithFilters} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {}

/**
 * Component to display the single most recent filter from localStorage.
 * Card layout: search icon, filter text (city bold), Zatwierdź button.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersRegions = (props: IProps) => {
    const {className, style, ...rest} = props;

    const {recentFilters, latestQuery, shouldShow, currentFormValues} = useRecentFiltersDisplay();

    if (!shouldShow || recentFilters.length === 0) {
        return null;
    }

    const [recentFilter] = recentFilters;

    return (
        <div className={cx(recentFiltersContainerStyle, className)} style={style} {...rest}>
            <Text variant="body_copy_1" className={recentFiltersTitleStyle}>
                Twoje ostatnie wyszukiwania
            </Text>

            <RecentFilterRegionCard
                filterText={getRecentFilterFilterText(recentFilter)}
                url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
            />
        </div>
    );
};

interface RecentFilterRegionCardProps {
    filterText: string;
    url: string;
}

const RecentFilterRegionCard = ({filterText, url}: RecentFilterRegionCardProps) => {
    const {boldPart, rest} = getFilterTextParts(filterText);

    return (
        <div className={recentFilterCardStyle}>
            <SearchIcon size="1.6" wrapperSize="1.6" className={searchIconStyle} />

            <div className={recentFilterCardContentStyle}>
                <Text variant="info_txt_1" className={recentFilterTextStyle} as="span">
                    {boldPart ? (
                        <>
                            <Text as="span" variant="info_txt_1" strong>
                                {boldPart}
                            </Text>
                            {rest}
                        </>
                    ) : (
                        filterText
                    )}
                </Text>
            </div>

            <Button href={url} variant="highlight_primary" size="small" className={confirmButtonStyle}>
                Zatwierdź
            </Button>
        </div>
    );
};

const recentFiltersContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});

const recentFiltersTitleStyle = css({
    mb: 0.5
});

const recentFilterCardStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    minHeight: "32px",
    px: 1.5,
    py: 0.5,
    backgroundColor: "var(--colors-background-100)",
    border: "1px solid var(--colors-gray-600)",
    borderRadius: "16px"
});

const searchIconStyle = css({
    flexShrink: 0
});

const recentFilterCardContentStyle = css({
    flex: 1,
    minWidth: 0
});

const recentFilterTextStyle = css({
    display: "block",
    color: "var(--colors-gray-800)"
});

const confirmButtonStyle = css({
    flexShrink: 0,
    textTransform: "uppercase"
});
import {ComponentProps} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {SearchIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {useRecentFiltersDisplay} from "../hooks/use_recent_filters_display";
import {recentFiltersLinkConfig} from "../utils/build_recent_filters_search_values";
import {getFilterTextParts, getRecentFilterFilterText, getRecentFilterSearchUrlWithFilters} from "../utils/recent_filters_display_utils";

interface IProps extends ComponentProps<"div"> {}

/**
 * Component to display the single most recent filter from localStorage.
 * Card layout: search icon, filter text (city bold), Zatwierdź button.
 * Only shows if user doesn't have active filters.
 */
export const RecentFiltersRegions = (props: IProps) => {
    const {className, style, ...rest} = props;

    const {recentFilters, latestQuery, shouldShow, currentFormValues} = useRecentFiltersDisplay();

    if (!shouldShow || recentFilters.length === 0) {
        return null;
    }

    const [recentFilter] = recentFilters;

    return (
        <div className={cx(recentFiltersContainerStyle, className)} style={style} {...rest}>
            <Text variant="body_copy_1" className={recentFiltersTitleStyle}>
                Twoje ostatnie wyszukiwania
            </Text>

            <RecentFilterRegionCard
                filterText={getRecentFilterFilterText(recentFilter)}
                url={getRecentFilterSearchUrlWithFilters({...recentFiltersLinkConfig, recentFilter, currentFormValues, latestQuery})}
            />
        </div>
    );
};

interface RecentFilterRegionCardProps {
    filterText: string;
    url: string;
}

const RecentFilterRegionCard = ({filterText, url}: RecentFilterRegionCardProps) => {
    const {boldPart, rest} = getFilterTextParts(filterText);

    return (
        <div className={recentFilterCardStyle}>
            <SearchIcon size="1.6" wrapperSize="1.6" className={searchIconStyle} />

            <div className={recentFilterCardContentStyle}>
                <Text variant="info_txt_1" className={recentFilterTextStyle} as="span">
                    {boldPart ? (
                        <>
                            <Text as="span" variant="info_txt_1" strong>
                                {boldPart}
                            </Text>
                            {rest}
                        </>
                    ) : (
                        filterText
                    )}
                </Text>
            </div>

            <Button href={url} variant="highlight_primary" size="small" className={confirmButtonStyle}>
                Zatwierdź
            </Button>
        </div>
    );
};

const recentFiltersContainerStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    mb: 3
});

const recentFiltersTitleStyle = css({
    mb: 0.5
});

const recentFilterCardStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    minHeight: "32px",
    px: 1.5,
    py: 0.5,
    backgroundColor: "var(--colors-background-100)",
    border: "1px solid var(--colors-gray-600)",
    borderRadius: "16px"
});

const searchIconStyle = css({
    flexShrink: 0
});

const recentFilterCardContentStyle = css({
    flex: 1,
    minWidth: 0
});

const recentFilterTextStyle = css({
    display: "block",
    color: "var(--colors-gray-800)"
});

const confirmButtonStyle = css({
    flexShrink: 0,
    textTransform: "uppercase"
});
